
import { TypedVue } from "@/store/types";
import { Component, Prop } from "vue-property-decorator";
import { CompetencyStatus } from "@/lib/competencies";
import { OrientationTextResult } from "@/lib/elraReport7DynamicText";
import { STATUS_COLORS, STATUS_LABELS } from "./shared";

export interface OrientationTraitBar {
  key: string;
  name: string;
  score: number;
  status: CompetencyStatus;
  benchLow: number;
  benchHigh: number;
  definition: string;
  behaviours: string[];
}

export interface OrientationCardData {
  id: string;
  letter: string;
  label: string;
  subtitle: string;
  traits: OrientationTraitBar[];
  texts: OrientationTextResult;
  prioritizedCount: number;
}

@Component
export default class OrientationCard extends TypedVue {
  @Prop({ required: true })
  readonly orientation!: OrientationCardData;

  public expanded: Record<string, boolean> = {};

  statusLabel(status: CompetencyStatus): string {
    return STATUS_LABELS[status];
  }

  barColor(status: CompetencyStatus): string {
    return STATUS_COLORS[status];
  }

  toggleTrait(key: string): void {
    this.$set(this.expanded, key, !this.expanded[key]);
  }
}
